import React, { Component, Fragment } from 'react'
import { Button, Col, Modal, Popconfirm, Row, Tabs } from 'antd'
import PayLinesList from './PayLinesList'
import Documents from '../../../Common/Documents/DocumentsCont'
import ReceiptForm from './ReceiptForm'
import { streamUrl } from '../../../../variables/index'
import Authentication from '../../../../modules/Authentication'

const { TabPane } = Tabs

class ReceiptModal extends Component {
  auth = new Authentication()

  render() {
    const {
      visible,
      type,
      receipt,
      onCancel,
      submitting,
      removing,
      submit,
      remove,
      update,
      formRef,
      fetchingReceipt,
      showEmail,
      fetchingEmailTemplate,
    } = this.props
    return (
      <Modal
        title={type !== 'edit' ? 'Create a Receipt' : 'Update Receipt'}
        visible={visible}
        onCancel={onCancel}
        distoryOnClose={true}
        width={1333}
        footer={
          (type === 'edit' && receipt.status === 'Draft') || type === 'new' ? (
            <Row>
              <Col span={24} style={{ textAlign: 'right' }}>
                {type === 'edit' && (
                  <Fragment>
                    <Button loading={fetchingEmailTemplate} onClick={showEmail} style={{ marginLeft: 8 }} icon={'mail'}>
                      Email
                    </Button>
                    <Button
                      style={{ marginLeft: 8 }}
                      icon={'file-pdf'}
                      onClick={() =>
                        window.open(
                          `${streamUrl}pdf/${receipt._id}?access_token=${this.auth.getAccessToken()}`,
                          '_blank'
                        )
                      }>
                      PDF preview
                    </Button>
                    <Popconfirm
                      title="Are you sure remove this Receipt?"
                      onConfirm={remove}
                      okText="Yes"
                      cancelText="No">
                      <Button type="danger" loading={removing} style={{ marginLeft: 8 }}>
                        Remove
                      </Button>
                    </Popconfirm>
                  </Fragment>
                )}
                <Button
                  style={{ marginLeft: 8 }}
                  loading={submitting}
                  type="primary"
                  onClick={type !== 'edit' ? submit : update}>
                  {type === 'edit' ? 'Update' : 'Submit'}
                </Button>
              </Col>
            </Row>
          ) : null
        }>
        <Tabs defaultActiveKey="form">
          <TabPane tab="Form" key="form">
            <ReceiptForm ref={formRef} loading={fetchingReceipt} {...this.props} />
            <PayLinesList {...this.props} />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab="Files" key="files">
            <Documents
              editable={receipt.status === 'Draft'}
              footer={false}
              category={false}
              owner={receipt}
              email={true}
            />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

ReceiptModal.propTypes = {}
ReceiptModal.defaultProps = {}

export default ReceiptModal
